

export default {
  isInCart: state => itemId => {
    return state.cartItems.some((item) => item.objectID === itemId)
  },
  isInWishList: state => itemId => {
    return state.wishList.some((item) => item.objectID === itemId)
  },
  getCartItem: state => itemId => {
    const result = state.cartItems.filter((item) => item.objectID === itemId)
    return result.length ? result.pop() : []
  },
  getProducts: state => {
    return state.products
  },
  getCartLength: state => {
    let total = 0;
    state.cartItems.map(product => {
      total += product.quantity
    });
    return total;
  },
  cartTotalPrice: state => {
    let total = 0;
    state.cartItems.map(product => {
      total += product.price * product.quantity;

      if (product.selectedSauces) {
      product.selectedSauces.map(sauce => {
        total += sauce.price * product.quantity
      });
    }

    if (product.selectedMeats) {
      product.selectedMeats.map(meat => {
        total += meat.price * product.quantity
      });
    }
    if (product.selectedSalads) {
      product.selectedSalads.map(salad => {
        total += salad.price * product.quantity
      });
    }
      if (product.selectedExtras) {
      product.selectedExtras.map(extra => {
        total += extra.price * product.quantity
      });
    }

    if (product.selectedPommRice) {
      total += product.selectedPommRice.price;
    }
    });

    return total;
  },
  minimumPriceReached: (state,getters) => {
    return (15 - getters.cartTotalPrice)
  },
  getShippingAddress: (state) => {
    return state.shippingAddress;
  },
  getPaymentMethod: (state) => {
    return state.paymentMethod;
  }
}
